import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from "@angular/material/sort";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {Router} from "@angular/router";

// service
import {AuthService} from "../../../shared/services/auth.service";
import {CarsService} from "../../../shared/services/cars.service";

// models
import {Car} from "../../../shared/models/cars/car";
import {Cars} from "../../../shared/models/cars/cars";


@Component({
    selector: 'app-cars-list',
    templateUrl: './cars-list.component.html',
    styleUrls: ['./cars-list.component.scss', './../../secure.component.scss']
})
export class CarsListComponent implements OnInit, AfterViewInit {

    @Input() public isArchive = 'false';

    @ViewChild(MatSort) public sort!: MatSort;
    @ViewChild(MatPaginator) public paginator!: MatPaginator;

    public isLoading = false;
    public displayedColumns: string[] = ['inspection_date', 'insurance_end_date', 'registration_number', 'car_brand', 'actions'];
    public cars$ = new MatTableDataSource<Car>();
    public pageSizeOptions: number[] = [6, 12, 24, 48];
    public totalRows = 0;
    public pageSize = 6;
    public currentPage = 0;
    public carsSort = 'inspection_date';
    public carsDirection = 'asc';
    public searchFilter = '';

    constructor(protected authService: AuthService,
                private router: Router,
                private carsService: CarsService) {
    }

    ngAfterViewInit(): void {
        this.cars$.paginator = this.paginator;
        this.paginator.firstPage();
    }

    ngOnInit(): void {
        this.loadCars();
    }

    public pageChanged(event: PageEvent): void {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex + 1;
        this.loadCars();
    }

    public sortData(sort: Sort): void {
        switch (sort.active) {
            case 'inspection_date':
                this.carsSort = sort.active;
                this.carsDirection = sort.direction;
                this.loadCars();
                return
            case 'insurance_end_date':
                this.carsSort = sort.active;
                this.carsDirection = sort.direction;
                this.loadCars();
                return
            case 'registration_number':
                this.carsSort = sort.active;
                this.carsDirection = sort.direction;
                this.loadCars();
                return
            case 'car_brand':
                this.carsSort = sort.active;
                this.carsDirection = sort.direction;
                this.loadCars();
                return
            default:
                return
        }
    }

    public addCar(): void {
        this.router.navigateByUrl(`secure/car-add`).then();
    }

    public showCar(id: number): void {
        this.router.navigateByUrl(`secure/car-show/${id}`).then();
    }

    public setSearchFilter(): void {
        this.searchFilter.trim().toLowerCase();
        this.loadCars();
        this.paginator.firstPage();
    }

    private loadCars(): void {
        this.isLoading = true;
        this.carsService.index(
            this.currentPage,
            this.pageSize,
            this.carsSort,
            this.carsDirection,
            this.searchFilter,
            this.isArchive
        ).subscribe((cars: Cars): void => {
                this.cars$ = new MatTableDataSource(cars.data);
                this.cars$.sort = this.sort;
                this.paginator.length = cars.meta.total;
                this.paginator.pageIndex = 0;
                this.paginator.pageIndex = cars.meta.current_page - 1;
                this.isLoading = false;
            }
        );
    }
}
